import {faChevronDown, faChevronUp} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import * as React from 'react';
import {FunctionComponent, useState} from 'react';
import {Loader} from './Loader';

export interface ShrinkExpandFlatDetailsProps {
    id: string | null | undefined;
    defaultExpanded?: boolean;
    title: string;
    children: any;
    onExpand?: () => void;
    loading?: boolean;
    titleAddon?: any;
}

export const ShrinkExpandFlatDetails: FunctionComponent<ShrinkExpandFlatDetailsProps> = (props) => {
    const [expanded, setExpanded] = useState(props.defaultExpanded !== undefined ? props.defaultExpanded : true);

    React.useEffect(() => {

        setExpanded(false);
    }, [props.id]);

    return (
        <section className={'card pb-2 mb-4 ' + (expanded ? 'expanded' : 'shrinked')}>
            <div className="card-header flex">
                <span className="cursor-pointer" onClick={() => {
                    setExpanded(!expanded);
                    if (typeof (props.onExpand) === 'function') {
                        props.onExpand();
                    }
                }}>{props.title}</span>
                {expanded && <div className="ml-auto">{props.titleAddon}</div>}
                <button className="btn btn-secondary ml-auto h-8" onClick={() => {
                    setExpanded(!expanded);
                    if (!expanded && typeof (props.onExpand) === 'function') {
                        props.onExpand();
                    }
                }}>
                    {expanded ? 'Shrink section' : 'Expand section'}
                    <FontAwesomeIcon
                        className="fill-current ml-4 text-m-gray-6"
                        icon={expanded ? faChevronUp : faChevronDown}
                    />
                </button>
            </div>
            <div className="card-body bg-m-gray-2 m-2">{expanded ? (props.loading ? <Loader loading={props.loading}/> : props.children) : ''}
            </div>

        </section>
    );
};
